import React from "react"
import styles from "./styles"
import { View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import ProgressCircle from "@Components/PercentageCircle"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"

export const EvaluationQuizzHeader = (props) => {
    const { selectedQuizz, isResult, questionLength, correctQuizzLength, fetchingResponse } = props
    const percentage = 100

    return (
        <View style={styles.header}>
            {fetchingResponse ? (
                <View style={{ alignSelf: "center" }}>
                    <OpenSansText color={baseColors.white}>Chargement en cours...</OpenSansText>
                </View>
            ) : (
                <>
                    <BreeSerifText style={{ marginBottom: 15 }} fontSize={22} color={"white"}>
                        {selectedQuizz?.title}
                    </BreeSerifText>
                    <OpenSansText style={{ marginBottom: isResult ? 0 : 25 }} fontSize={16} color={"white"}>
                        {selectedQuizz?.subContent?.title ?? ""}
                    </OpenSansText>
                    <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                        <OpenSansText fontWeight={"bold"} fontSize={16} color={"white"}>
                            {`0${questionLength ?? 0} question${questionLength > 1 ? "s" : ""}`}
                        </OpenSansText>
                        {/* {isResult && (
                            <ProgressCircle
                                percent={percentage}
                                radius={40}
                                borderWidth={7}
                                color={baseColors.green.dark}
                                shadowColor="white"
                                bgColor={baseColors.green.primary}
                            >
                                <OpenSansText style={{ color: "white", fontSize: 18 }}>
                                    {questionLength} / {questionLength}
                                </OpenSansText>
                            </ProgressCircle>
                        )} */}
                    </View>
                </>
            )}
        </View>
    )
}
